/**
 * Apply data from dataToUpdate as "patches" to the current table data.
 *
 * @param {Array<*>} oldData - Current table data.
 * @param {Map<string, *>} dataToUpdate - Map containing keys mapped to updated values.
 * @param {string} idKey - Key to identify row data.
 * @returns {Array<*>} - Updated table data.
 */
const applyChanges = (oldData, dataToUpdate, idKey) => {
  return oldData.map((data) => {
    if (dataToUpdate.has(data[idKey])) {
      return {
        ...data,
        ...dataToUpdate.get(data[idKey]),
      };
    }
    return data;
  });
};

export default applyChanges;
